module.exports = __webpack_public_path__ + "img/ico-cool.45be97c5.svg";